import { render, staticRenderFns } from "./ServicesTrendStatistics.vue?vue&type=template&id=0bbc82d5"
import script from "./ServicesTrendStatistics.vue?vue&type=script&lang=ts"
export * from "./ServicesTrendStatistics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports